import { GlobalState } from '../../../../types.global';

export * from './basic';
export * from './suggestions';
export * from './searchTagsSelctors';

import { urlPrettifiers } from '../utils';
import { selectHighlighted, selectSuggestions } from './suggestions';
import { getTerm, checkIsUrl } from '../utils';
import { Suggestion } from '../types';

export const checkPreselectMatch = (
  suggestion: Suggestion,
  provided: string
): string =>
  [
    suggestion.displayUrl,
    urlPrettifiers.removePrefix(suggestion.displayUrl || suggestion.url),
    // suggestion.term,
    // suggestion.url,
  ]
    .filter(Boolean)
    .map((text) => text.toLowerCase())
    .find((text) => text.toLowerCase().startsWith(provided.toLowerCase()));

export const selectRendered = (state: GlobalState): string => {
  const { provided } = state.search;

  // for performance reasons there is this first check
  if (state.search.highlighted.id && selectHighlighted(state)) {
    const suggestions = selectSuggestions(state);
    const suggestion = selectHighlighted(state);

    const index = suggestions.indexOf(suggestion);

    if (index >= 1 || state.search.highlighted.inputType !== 'preselected') {
      return getTerm(suggestion);
    }

    if (state.search.highlighted.inputType !== 'preselected') return provided;

    const matchText = checkPreselectMatch(suggestion, provided);

    if (!matchText) return provided;

    const startsAt = matchText.indexOf(provided.toLowerCase());
    return provided + matchText.substr(startsAt + provided.length);
  }

  if (state.search.isSubmitted && checkIsUrl(provided)) {
    return urlPrettifiers.removePrefix(provided);
  }

  return provided;
};
